exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* HACK: DataPopover should be below the search box */\n.DataPopoverContainer {\n  z-index: 2;\n}\n", ""]);

// exports
